import React from 'react';
import { useSelector } from 'react-redux';

import LeftNavigationButton from './LeftNavigationButton/LeftNavigationButton';
import buttons from './buttons';
import { getUserleftNavigationAndMenuButtons, isUserVisitor } from '../../selectors/users';

import styles from './LeftNavigation.module.scss';

const LeftNavigation = () => {
  const isVisitor = useSelector(isUserVisitor);
  const leftNavigationAndMenuButtons = useSelector(getUserleftNavigationAndMenuButtons);
  const inboxUnread = useSelector((state) => state.capweb.unread);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const filterUserButtons = () => {
    if (isVisitor) {
      return buttons.filter((button) => button.allowVisitor);
    }

    if (!isAuthenticated) {
      return '';
    }

    return buttons.filter((button) =>
      leftNavigationAndMenuButtons?.map((userButton) => userButton.id === button.id),
    );
  };

  if (!isAuthenticated) return '';

  const items = filterUserButtons().map((item) => (
    <LeftNavigationButton
      key={item.id}
      href={item.to}
      title={item.title}
      tagManagerName={item.tagManagerName}
      background={item.image}
    >
      <>
        {item.id === 'cap' && inboxUnread > 0 && (
          <div className='position-absolute top-0 end-50'>
            <span className='badge bg-black'>{inboxUnread}</span>
          </div>
        )}
      </>
    </LeftNavigationButton>
  ));

  return (
    <ul
      className={`${styles.leftNavigationList} d-none d-md-block`}
      id='leftNavigation'
      style={{ zIndex: 1000 }}
    >
      {items}
    </ul>
  );
};

export default LeftNavigation;
